<script setup lang="ts">
import { inject } from "vue";
import type { DynamicDialogOptions } from "primevue/dynamicdialogoptions";
import { MContainer } from "@xlabmedical/medic-web-framework";

const dialogRef = inject("dialogRef") as DynamicDialogOptions;
const params = dialogRef.value.data as { text: string };
</script>

<template>
    <MContainer class="justify-center h-full">
        <pre class="text-preview">{{ params.text || "" }}</pre>
    </MContainer>
</template>

<style scoped>
.text-preview {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 16px;
    overflow: auto;
    white-space: pre-wrap;
    word-break: break-word;
    background: rgba(255, 255, 255, 0.04);
    border-radius: 12px;
    color: var(--webcad-primary-text-color);
}
</style>
